import React, { InputHTMLAttributes } from "react";
import {
  StyledCheckmark,
  StyledRadiobutton,
  StyledRadiobuttonContainer,
} from "./RadioButton.styled";

interface RadioButtonProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  onChange?: (value: boolean) => void;
  value: boolean;
  disabled?: boolean;
}

export const RadioButton = ({
  onChange,
  value,
  ...props
}: RadioButtonProps) => {
  return (
    <StyledRadiobuttonContainer disabled={props.disabled}>
      <StyledRadiobutton
        type={"radio"}
        onChange={(e) => {
          if (!props.disabled && onChange) {
            onChange(e.target.checked);
          }
        }}
        checked={value}
        {...props}
        disabled={props.disabled}
      />
      <StyledCheckmark $disabled={props.disabled} data-testid="checkmark" />
    </StyledRadiobuttonContainer>
  );
};
